<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 mx-auto md-medium-size-100">
      <tabs
        :tab-name="[
          'الإعدادات',
          'بيانات الجهة',
          'حول النظام',
          // 'النسخ الاحتياطي',
        ]"
        :tab-icon="['settings', 'location_on', 'help', 'backup']"
        class="page-subcategories"
        nav-pills-icons
        plain
        color-button="success"
      >
        <!-- here you can add your content for tab-content -->
        <template slot="tab-pane-1">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title">اعدادات عامة</h4>
              </div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-size-25 md-small-size-100 mtb-25">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>مدير إدارة الشؤون الإدارية</label>
                    <md-input v-model="hrManagerName"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-25 md-small-size-100 mtb-25">
                  <md-field>
                    <label>اللغة الإفتراضية</label>
                    <md-select v-model="lang">
                      <md-option value="ar-LY">اللغة العربية</md-option>
                      <md-option value="en-US">اللغة الإنجليزي</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-25 md-small-size-100 mt-25">
                  <md-datepicker
                    :md-open-on-focus="false"
                    v-model="startingDate"
                  >
                    <label class="mr-28">تاريخ البداية</label>
                  </md-datepicker>
                </div>

                <!-- <div
                  class="md-layout-item md-size-25 md-small-size-100 mt-25"
                  style="padding-right: 0"
                >
                  <md-checkbox v-model="linkingByWarehouse">
                    الربط مع نظام إدارة المخازن
                  </md-checkbox>
                </div> -->

                <div
                  v-if="isPrivateCompanyMode === 'false'"
                  class="md-layout-item md-size-25 md-small-size-100 mt-25"
                  style="padding-right: 0"
                >
                  <md-checkbox v-model="autoEmployeesBonsesIncrement">
                    زيادة العلاوات السنويا بشكل تلقائي
                  </md-checkbox>
                </div>

                <div
                  class="md-layout-item md-size-25 md-small-size-100 mt-25"
                  style="padding-right: 0"
                >
                  <md-checkbox v-model="autoVacationBalancesIncrement">
                    إضافة أرصدة الإجازات بشكل تلقائي
                  </md-checkbox>
                </div>

                <div
                  v-if="autoVacationBalancesIncrement == true"
                  class="md-layout-item md-size-25 md-small-size-100 mtb-25"
                >
                  <md-field>
                    <label>آلية الاحتساب</label>
                    <md-select
                      v-model="autoSetMonthlyIncreaseOfVacationMechanism"
                    >
                      <md-option value="Year">سنوي</md-option>
                      <md-option value="Month">شهري</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div
                  class="md-layout-item md-size-25 md-small-size-100 mt-25"
                  style="padding-right: 0"
                >
                  <md-checkbox v-model="autoSetMonthlyIncreaseOfVacation">
                    تحديث قيمة أرصدة الإجازات ذاتيا
                  </md-checkbox>
                </div>

                <div
                  class="md-layout-item md-size-25 md-small-size-100 mtb-25"
                  style="padding-right: 0"
                >
                  <md-checkbox v-model="privateCompanyMode">
                    نمط الشركات الخاصة
                  </md-checkbox>
                </div>

                <div
                  class="md-layout-item md-size-25 md-small-size-100 mtb-25"
                  style="padding-right: 0"
                >
                  <md-checkbox v-model="enableUserDeviceIdVerification">
                    تفعيل التحقق من معرف الأجهزة
                  </md-checkbox>
                </div>
                <div
                  class="md-layout-item md-size-25 md-small-size-100 mtb-25"
                  style="padding-right: 0"
                >
                  <md-checkbox v-model="isMultiCurrency">
                    تعدد العملات
                  </md-checkbox>
                </div>

                <div
                  class="md-layout-item md-size-25 md-small-size-100 mtb-25"
                  style="padding-right: 0"
                >
                  <md-checkbox v-model="isHrVacationApprovalRequired">
                    تعدد موافقات طلبات الاجازة
                  </md-checkbox>
                </div>

                <div class="md-layout-item md-size-25 md-small-size-100 mtb-25">
                  <md-field>
                    <label>فترة اشعار طلب الاجازة (بالأيام)</label>
                    <md-input v-model="preVacationRequestDaysCount"></md-input>
                  </md-field>
                </div>
              </div>
            </md-card-content>
          </md-card>
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title">الحضور والانصراف</h4>
              </div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout">
                <div
                  class="md-layout-item md-size-25 md-small-size-100 mtb-25"
                  style="padding-right: 0"
                >
                  <md-checkbox v-model="enableAttendanceService">
                    تفعيل الحضور والانصراف
                  </md-checkbox>
                </div>

                <div
                  class="md-layout-item md-size-25 md-small-size-100 mtb-25"
                  style="padding-right: 0"
                >
                  <md-checkbox
                    :disabled="!enableAttendanceService"
                    v-model="noTimeInException"
                  >
                    احتساب الحضور من بصمة الخروج
                  </md-checkbox>
                </div>

                <div
                  class="md-layout-item md-size-25 md-small-size-100 mtb-25"
                  style="padding-right: 0"
                >
                  <md-checkbox
                    :disabled="!enableAttendanceService"
                    v-model="autoGetAttendanceLogFromZK"
                  >
                    سحب البصمات بشكل ذاتي
                  </md-checkbox>
                </div>

                <div
                  v-if="autoGetAttendanceLogFromZK"
                  class="md-layout-item md-size-25 md-small-size-100 mt-25"
                >
                  <md-field>
                    <label>سحب البصمات خلال فترة ( دقائق )</label>
                    <md-input
                      :disabled="!enableAttendanceService"
                      v-model="autoGetAttendanceTimeInMinutes"
                    ></md-input>
                  </md-field>
                </div>

                <div
                  class="md-layout-item md-size-25 md-small-size-100 mtb-25"
                  style="padding-right: 0"
                >
                  <md-checkbox
                    :disabled="!enableAttendanceService"
                    v-model="verifyAttendanceByCoordinates"
                  >
                    تأكيد الحضور حسب الموقع
                  </md-checkbox>
                </div>

                <div
                  class="md-layout-item md-size-25 md-small-size-100 mtb-25"
                  style="padding-right: 0"
                >
                  <md-checkbox v-model="isMultiShiftsEnabled">
                    تعدد فترات العمل للموظف
                  </md-checkbox>
                </div>

                <div class="md-layout-item md-size-25 md-small-size-100 mt-25">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>عدد الأيام المسموحة للغياب</label>
                    <md-input
                      :disabled="!enableAttendanceService"
                      v-model="AbsanceDaysLimit"
                    ></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-25 md-small-size-100 mtb-25">
                  <md-field>
                    <label>آلية خصم التأخير</label>
                    <md-select v-model="attendanceDeductionMethod">
                      <md-option value="PerHourRate"
                        >حسب تكلفة الساعة</md-option
                      >
                      <md-option value="PerPenalty">حسب الجزاءات</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div
                  v-if="attendanceDeductionMethod === 'PerHourRate'"
                  class="md-layout-item md-size-25 md-small-size-100 mtb-25"
                  style="padding-right: 0"
                >
                  <md-checkbox v-model="isAbsenceDeductionEnabled">
                    تفعيل خصم الغياب
                  </md-checkbox>
                </div>

                <div
                  v-if="
                    attendanceDeductionMethod === 'PerHourRate' &&
                    isAbsenceDeductionEnabled
                  "
                  class="md-layout-item md-size-25 md-small-size-100 mt-25"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>عدد أيام خصم الغياب</label>
                    <md-input
                      v-model="salaryAbsenceDeductionDays"
                      type="number"
                      min="1"
                    ></md-input>
                  </md-field>
                </div>

                <div
                  class="md-layout-item md-size-25 md-small-size-100 mtb-25"
                  style="padding-right: 0"
                >
                  <md-checkbox v-model="enableQrAttendanceVerification">
                    تفعيل QR في اثبات الحضور
                  </md-checkbox>
                </div>

                <div
                  class="md-layout-item md-size-25 md-small-size-100 mtb-25"
                  style="padding-right: 0"
                >
                  <md-checkbox v-model="isTrackingEnabled">
                    تفعيل النمط الذاتي
                  </md-checkbox>
                </div>
              </div>
            </md-card-content>
          </md-card>
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title">المرتبات</h4>
              </div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout">
                <div
                  class="md-layout-item md-size-25 md-small-size-100 mt-25"
                  style="padding-right: 0"
                >
                  <md-checkbox v-model="isSalariesEnabled">
                    تفعيل المرتبات
                  </md-checkbox>
                </div>

                <!-- <div
                  v-if="isSalariesEnabled == true"
                  class="md-layout-item md-size-25 md-small-size-100 mt-25"
                  style="padding-right: 0"
                >
                  <md-checkbox v-model="linkingByAccounting">
                    الربط مع نظام إدارة الحسابات
                  </md-checkbox>
                </div>

                <div
                  class="md-layout-item md-size-25 md-small-size-100 mtb-25"
                  style="padding-right: 0"
                >
                  <md-checkbox
                    :disabled="!linkingByAccounting"
                    v-model="calculateSalariesByClassification"
                  >
                    صرف المرتبات حسب الفروع
                  </md-checkbox>
                </div> -->

                <!-- <div
                  v-if="isSalariesEnabled == true"
                  class="md-layout-item md-size-25 md-small-size-100 mt-25"
                  style="padding-right: 0"
                >
                  <md-checkbox v-model="CalculateSalriesFromTimeSheet"
                    >عدم احتساب المرتب من جدول الحضور والإنصراف
                  </md-checkbox>
                </div> -->

                <div
                  class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>
                      يوم احتساب المرتب (القيمة المسموحة من 15 : 30)
                    </label>
                    <md-input
                      type="number"
                      min="15"
                      max="30"
                      v-model="salaryDay"
                    ></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-25 md-small-size-100 mtb-25">
                  <md-field>
                    <label>آلية احتساب المرتب</label>
                    <md-select v-model="salaryCalculationMethod">
                      <md-option :value="1">احتساب من جدول الحضور</md-option>
                      <md-option :value="2">احتساب من سجل الحضور</md-option>
                      <md-option :value="3">بدون احتساب الحضور</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div
                  class="md-layout-item md-size-25 md-small-size-100 mtb-25"
                  style="padding-right: 0"
                >
                  <md-checkbox v-model="isNetSalaryRoundingEnabled">
                    تقريب صافي المرتب
                  </md-checkbox>
                </div>
              </div>
            </md-card-content>
          </md-card>

          <md-card>
            <md-card-content>
              <div class="md-layout">
                <!-- <div class="md-layout-item md-size-25 ml-15 mtb-25">
                  <md-checkbox v-model="sentToArchiveJobTitle">تحويل المراسلات إلى المحفوظات</md-checkbox>
                </div> -->

                <div
                  class="md-layout-item md-size-100 md-small-size-100 mt-25 mtb-25 center-content"
                >
                  <md-button
                    @click="SaveSetings"
                    class="md-success btn_nanosoft"
                    >حفظ</md-button
                  >
                </div>
              </div>
            </md-card-content>
          </md-card>
        </template>
        <template slot="tab-pane-2">
          <md-card>
            <md-card-content>
              <div class="md-layout">
                <div
                  class="md-layout-item md-size-25 md-small-size-100 ml-15 mtb-25"
                >
                  <ValidationProvider name="name" rules="required">
                    <md-field>
                      <label>اسم الجهة</label>
                      <md-input v-model="fullName" type="email"></md-input>
                    </md-field>
                  </ValidationProvider>
                </div>
                <div
                  class="md-layout-item md-size-25 md-small-size-100 ml-15 mtb-25"
                >
                  <md-field>
                    <label>الوصف الوظيفي لعمل الجهة</label>
                    <md-input v-model="shortName" type="email"></md-input>
                  </md-field>
                </div>
                <div
                  class="md-layout-item md-size-25 md-small-size-100 ml-15 mtb-25"
                >
                  <ValidationProvider name="name" rules="required">
                    <md-field>
                      <label>الإسم الإنجليزي</label>
                      <md-input v-model="englishName" type="email"></md-input>
                    </md-field>
                  </ValidationProvider>
                </div>
                <!-- <div class="md-layout-item md-size-25 ml-15 mtb-25">
                      <ValidationProvider name="name" rules="required" v-slot="{ passed, failed }">
                        <md-field
                          :class="[
                                { 'md-error': failed },
                                { 'md-valid': passed },
                              ]"
                        >
                          <label></label>
                          <md-input v-model="fullName" type="email"></md-input>
                          <slide-y-down-transition>
                            <md-icon class="error" v-show="failed">close</md-icon>
                          </slide-y-down-transition>
                          <slide-y-down-transition>
                            <md-icon class="success" v-show="passed">done</md-icon>
                          </slide-y-down-transition>
                        </md-field>
                      </ValidationProvider>
                    </div> -->

                <div
                  class="md-layout-item md-size-25 md-small-size-100 ml-15 mtb-25"
                >
                  <ValidationProvider name="name" rules="required">
                    <md-field>
                      <label>العنوان</label>
                      <md-input v-model="address" type="email"></md-input>
                    </md-field>
                  </ValidationProvider>
                </div>
                <div
                  class="md-layout-item md-size-25 md-small-size-100 ml-15 mtb-25"
                >
                  <ValidationProvider name="Name" rules="required">
                    <md-field>
                      <label>رقم الهاتف</label>
                      <md-input v-model="phone" type="number"></md-input>
                    </md-field>
                  </ValidationProvider>
                </div>

                <div
                  class="md-layout-item md-size-25 md-small-size-100 ml-15 mtb-25"
                >
                  <ValidationProvider name="Name" rules="required">
                    <md-field>
                      <label>البريد الإلكتروني</label>
                      <md-input v-model="email" type="email"></md-input>
                    </md-field>
                  </ValidationProvider>
                </div>

                <div
                  class="md-layout-item md-size-25 md-small-size-100 ml-15 mtb-25"
                >
                  <ValidationProvider name="Name" rules="required">
                    <md-field>
                      <label>الفاكس</label>
                      <md-input v-model="fax" type="number"></md-input>
                    </md-field>
                  </ValidationProvider>
                </div>

                <div
                  class="md-layout-item md-size-25 md-small-size-100 ml-15 mtb-25"
                >
                  <ValidationProvider name="Name" rules="required">
                    <md-field>
                      <label>الموقع الإلكتروني</label>
                      <md-input v-model="web"></md-input>
                    </md-field>
                  </ValidationProvider>
                </div>

                <div
                  v-if="
                    pathLogo !=
                    'https://tpbspace.fra1.digitaloceanspaces.com/Demo/hr/CompanyLogo/'
                  "
                  class="md-layout-item md-size-30 mtb-25 ml-15"
                >
                  <md-table
                    :value="files"
                    class="paginated-table table-striped table-hover"
                  >
                    <md-table-row slot="md-table-row">
                      <md-table-cell
                        v-if="pathLogo != 'تمت الإضافة'"
                        md-label="اسم الصورة"
                      >
                        <div style="text-align: center">
                          <img :src="pathLogo" />
                        </div>
                      </md-table-cell>

                      <md-table-cell v-else md-label="اسم الصورة">
                        تمت الإضافة بنجاح
                      </md-table-cell>
                      <md-table-cell md-label>
                        <md-button
                          class="md-just-icon md-danger md-simple"
                          @click.native="deleteRow2(pathLogo)"
                        >
                          <md-icon>close</md-icon>
                        </md-button>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </div>

                <div
                  class="md-layout-item md-size-100 mt-25 mtb-25 center-content"
                >
                  <md-button class="md-black btn_nanosoft">
                    <label for="file-upload">إضافة شعار المؤسسة</label>
                    <input
                      id="file-upload"
                      type="file"
                      @change="onFileChange"
                      style="display: none; visibility: hidden"
                    />
                  </md-button>
                  <md-button class="md-black btn_nanosoft">
                    <label for="file-upload-login"
                      >إضافة صورة واجهة الدخول</label
                    >
                    <input
                      id="file-upload-login"
                      type="file"
                      @change="onLoginFileChange"
                      style="display: none; visibility: hidden"
                    />
                  </md-button>

                  <md-button @click="InfoSave" class="md-success btn_nanosoft"
                    >حفظ</md-button
                  >
                </div>
              </div>
            </md-card-content>
          </md-card>
        </template>
        <template slot="tab-pane-3">
          <md-card>
            <md-card-header>
              <br />
              <br />

              <h3 class="title">نظام "بياناتي" لإدارة الموارد البشرية</h3>
              <br />
              <h3 class="title">الإصدار : {{ version }}</h3>
              <br />
              <h3 class="title">البريد الإلكتروني: info@nanosoft.ly</h3>
              <br />
              <h3 class="title">الموقع: www.nanosoft.ly</h3>
              <br />
              <br />
              <br />
            </md-card-header>

            <!-- <md-card-content>
             
            </md-card-content> -->
          </md-card>
        </template>
        <!-- <template slot="tab-pane-4">
          <BackupSetting />
        </template> -->
      </tabs>
    </div>
  </div>
</template>
<script>
import { Tabs } from "@/components";
import env from "../../../../env";
import axios from "../../../components/service/HTTP";
// import { ModelListSelect } from "vue-search-select";
// import "vue-search-select/dist/VueSearchSelect.css";
import { SlideYDownTransition } from "vue2-transitions";
// import BackupSetting from "@/components/Settings/BackupSetting";
export default {
  created() {
    this.init();
    this.isPrivateCompanyMode = localStorage.getItem("privateCompanyMode");
  },
  components: {
    Tabs,
    // BackupSetting,
    // ModelListSelect,
    // SlideYDownTransition
  },
  computed: {
    globalCompanyInfo() {
      return this.$store.getters["global/companyInfo"];
    },
  },
  data() {
    return {
      isPrivateCompanyMode: null,
      errorMessage: "",
      hrManagerName: "",
      pathLogo: "",
      version: "",
      show: false,
      startingDate: null,
      // CalculateSalriesFromTimeSheet: false,
      autoVacationBalancesIncrement: false,
      autoSetMonthlyIncreaseOfVacationMechanism: null,
      autoSetMonthlyIncreaseOfVacation: false,
      autoGetAttendanceLogFromZK: false,
      autoGetAttendanceTimeInMinutes: 0,
      verifyAttendanceByCoordinates: false,
      noTimeInException: false,
      privateCompanyMode: false,
      isMultiShiftsEnabled: false,
      enableQrAttendanceVerification: false,
      isTrackingEnabled: false,
      isAbsenceDeductionEnabled: false,
      salaryAbsenceDeductionDays: 0,
      enableAttendanceService: false,
      AbsanceDaysLimit: 0,
      attendanceDeductionMethod: null,
      preVacationRequestDaysCount: 0,
      isHrVacationApprovalRequired: false,
      salaryDay: 0,
      isNetSalaryRoundingEnabled: false,
      autoEmployeesBonsesIncrement: false,
      // calculateSalariesByClassification: false,
      // linkingByWarehouse: false,
      enableUserDeviceIdVerification: false,
      isMultiCurrency: false,
      salaryCalculationMethod: null,
      departments: [],
      // linkingByAccounting: false,
      isSalariesEnabled: false,
      files: [],
      sentToArchiveJobTitle: false,
      outgoingSerialNumber: "",
      serialNumberBegining: "",
      lang: "",
      headJopId: "",
      headJop: "",
      archiveJobTitleId: "",
      fullName: "",
      shortName: "",
      englishName: "",
      address: "",
      phone: "",
      email: "",
      fax: "",
      web: "",
      organizations: [],
      organizationsId: "",
      backGroundFiles: [],
    };
  },
  async mounted() {
    if (this.globalCompanyInfo) {
      await this.setCompanyInfo();
    }
  },
  methods: {
    setCompanyInfo() {
      this.fullName = this.globalCompanyInfo.fullName;
      this.shortName = this.globalCompanyInfo.shortName;
      this.englishName = this.globalCompanyInfo.englishName;
      this.address = this.globalCompanyInfo.address;
      this.phone = this.globalCompanyInfo.phone;
      this.email = this.globalCompanyInfo.email;
      this.fax = this.globalCompanyInfo.fax;
      this.web = this.globalCompanyInfo.web;
      this.organizationsId = this.globalCompanyInfo.organizationId;
      this.organizations = this.globalCompanyInfo.organizations;
      this.pathLogo = this.globalCompanyInfo.path;
    },
    async SaveSetings() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        if (!this.lang) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال اسم الوحدة التنظيمية"
          );
        }
        if (!this.startingDate) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال اسم الوحدة التنظيمية"
          );
        }
        if (
          this.isAbsenceDeductionEnabled &&
          (!this.salaryAbsenceDeductionDays ||
            this.salaryAbsenceDeductionDays <= 0)
        ) {
          return this.notifyVue(
            "top",
            "center",
            "warning",
            "عفواً، عدد أيام خصم الغياب يجب أن يكون أكبر من 0"
          );
        }
        let schema = {
          hrManagerName: this.hrManagerName,
          startingDate: new Date(this.startingDate),
          // CalculateSalriesFromTimeSheet: this.CalculateSalriesFromTimeSheet,
          autoEmployeesBonsesIncrement: this.autoEmployeesBonsesIncrement,
          autoVacationBalancesIncrement: this.autoVacationBalancesIncrement,
          autoSetMonthlyIncreaseOfVacationMechanism:
            this.autoSetMonthlyIncreaseOfVacationMechanism,
          autoSetMonthlyIncreaseOfVacation:
            this.autoSetMonthlyIncreaseOfVacation,

          autoGetAttendanceLogFromZK: this.autoGetAttendanceLogFromZK,
          autoGetAttendanceTimeInMinutes: this.autoGetAttendanceTimeInMinutes,
          verifyAttendanceByCoordinates: this.verifyAttendanceByCoordinates,
          noTimeInException: this.noTimeInException,
          privateCompanyMode: this.privateCompanyMode,
          isMultiShiftsEnabled: this.isMultiShiftsEnabled,
          enableQrAttendanceVerification: this.enableQrAttendanceVerification,
          isTrackingEnabled: this.isTrackingEnabled,
          isAbsenceDeductionEnabled: this.isAbsenceDeductionEnabled,
          salaryAbsenceDeductionDays: this.salaryAbsenceDeductionDays,

          enableAttendanceService: this.enableAttendanceService,
          AbsenceDaysLimit: this.AbsanceDaysLimit,
          attendanceDeductionMethod: this.attendanceDeductionMethod,
          preVacationRequestDaysCount: this.preVacationRequestDaysCount,
          isHrVacationApprovalRequired: this.isHrVacationApprovalRequired,
          salaryDay: Number(this.salaryDay),
          isNetSalaryRoundingEnabled: this.isNetSalaryRoundingEnabled,
          // calculateSalariesByClassification:
          //   this.calculateSalariesByClassification,
          // linkingByWarehouse: this.linkingByWarehouse,
          enableUserDeviceIdVerification: this.enableUserDeviceIdVerification,
          isMultiCurrency: this.isMultiCurrency,
          salaryCalculationMethod: this.salaryCalculationMethod,
          // linkingByAccounting: this.linkingByAccounting,
          isSalariesEnabled: this.isSalariesEnabled,
          defaultCulture: this.lang,
        };
        let result = await axios.put(`${env.HR()}/api/Setting`, schema, {
          headers: { Authorization: "Bearer " + token },
        });

        this.notifyVue(
          "top",
          "center",
          "success",
          "تم الحفظ بنجاح سيتم تسجيل الخروج "
        );
        setTimeout(() => {
          this.$router.replace("/"); //window.location.href = '#/'
        }, 5000);
      } catch (error) {
        this.message(error);
      }
    },

    onFileChange(e) {
      console.warn("e", e);

      var files = e.target.files || e.dataTransfer.files;
      files[0].size;
      if (!files.length) return;
      let schema = {
        name: files[0].name,
        file: files[0],
        id: Math.random(),
        size: files[0].size,
      };
      this.files = [];
      this.files.unshift(schema);
      this.pathLogo = "تمت الإضافة";
    },

    onLoginFileChange(event) {
      console.warn("event", event);
      const file = event.target.files?.[0];

      if (!file) {
        return;
      }

      // Validate file type (optional - uncomment if needed)
      // const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
      // if (!allowedTypes.includes(file.type)) {
      //   this.notifyVue('top', 'center', 'danger', 'يرجى اختيار ملف صورة صالح');
      //   return;
      // }

      this.backGroundFiles = [
        {
          name: file.name,
          file: file,
          id: Date.now(),
          size: file.size,
        },
      ];

      this.pathLogo = "تمت الإضافة";
    },
    async InfoSave() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        if (!this.fullName) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال  اسم الجهة"
          );
        }
        let form = new FormData();
        form.append("ShortName", this.shortName == null ? "" : this.shortName);
        form.append("FullName", this.fullName);
        form.append(
          "EnglishName",
          this.englishName == null ? "" : this.englishName
        );
        form.append("Address", this.address == null ? "" : this.address);
        form.append("Phone", this.phone == null ? "" : this.phone);
        form.append("Email", this.email == null ? "" : this.email);
        form.append("Fax", this.fax);
        form.append("Web", this.web == null ? "" : this.web);
        form.append(
          "FileName",
          this.files.length === 0 ? [] : this.files[0].name
        );
        form.append(
          "FilesToAdd",
          this.files[0] === undefined ? [] : this.files[0].file
        );
        form.append(
          "BackGroundFiles",
          this.backGroundFiles.length === 0 ? [] : this.backGroundFiles[0].file
        );
        // form.append("OrganizationId", this.organizationsId);
        let result = await axios.put(`${env.HR()}/api/companyinfos/web`, form, {
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "multipart/form-data",
          },
        });
        this.notifyVue("top", "center", "success", " تم الحفظ بنجاح ");
        // this.init();
      } catch (error) {
        // console.log(error);

        return this.notifyVue(
          "top",
          "center",
          "danger",
          error.response.data.message
        );
      }

      // let form = new FormData();
      //   form.append("JobNumber", this.jobNamber);
      //   form.append("FirstName", this.name);
      //   form.append("FatherName", this.fname);
      //   form.append("GrandFatherName", this.gname);
      //   form.append("LastName", this.lname);
      //   form.append("NationalNumber", this.nid);
      //   form.append("Phone", this.phone);
      //   form.append("Email", this.email);
      //   form.append(
      //     "BirthDate",
      //     moment(this.date).format("YYYY/MM/DD hh:mm:ss")
      //   );
      //   form.append("Residence", this.resdaint);
      //   form.append("DepartmentId", this.dep);
      //   form.append("JobTitleId", this.jobTitle);
      //   form.append("IsManager", this.isManager);
      //   form.append("DigitalSignature", this.files);
      //   form.append("Image", []);
      //   form.append("DeleteImage", false);
      //   if (this.id === "") {
      //     let result = await axios.post(
      //       `${env.Mail()}/api/employees/web`,
      //       form,
      //       {
      //         headers: {
      //           Authorization: "Bearer " + token,
      //           "Content-Type": "multipart/form-data"
      //         }
      //       }
      //     );
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
    async Save() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        if (!this.nameunit) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال اسم الوحدة التنظيمية"
          );
        }
        let schema = {
          Name: this.nameunit,
          Number: this.number,
          Code: this.code,
          ParentId: this.departmentId,
          DepartmentClassificationsId: this.classificationId,
        };
        if (this.id === "") {
          let result = await axios.post(
            `${env.Mail()}/api/departments`,
            schema,
            {
              headers: { Authorization: "Bearer " + token },
            }
          );
        } else {
          let result = await axios.put(
            `${env.Mail()}/api/departments/${this.id}`,
            schema,
            {
              headers: { Authorization: "Bearer " + token },
            }
          );
        }
        this.init();
        this.id = "";
        return this.notifyVue("top", "center", "success", " تم الحفظ بنجاح ");
      } catch (error) {
        this.message(error);
      }
    },

    deleteRow2(item) {
      // let indexToDelete = this.files.findIndex(
      //   tableRow => tableRow.id === item.id

      // );

      this.files.splice(0, 1);

      this.pathLogo =
        "https://tpbspace.fra1.digitaloceanspaces.com/Demo/hr/CompanyLogo/";
    },

    message(error) {
      if (error.response.data.message != undefined) {
        this.errorMessage = error.response.data.message;
      } else {
        this.errorMessage =
          error.response.data.errors[
            Object.keys(error.response.data.errors)[0]
          ][0];
      }

      return this.notifyVue("top", "center", "danger", this.errorMessage);
    },
    async init() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        // let resultOne2 = await axios.get(`${env.HR()}/api/companyinfo`, {
        //   headers: { Authorization: "Bearer " + token },
        // });

        // let resultOne2 = await this.$store.getters["global/companyInfo"];
        // console.warn("resultOne2", resultOne2);

        // let resultLogo = await axios.get(`${env.HR()}/api/companyinfos/GetLogoPath`, {
        //   headers: { Authorization: "Bearer " + token }
        // });

        let resultOne = await axios.get(`${env.HR()}/api/Setting`, {
          headers: { Authorization: "Bearer " + token },
        });

        this.version = resultOne.data.data.version;
        this.hrManagerName = resultOne.data.data.hrManagerName;
        this.lang = resultOne.data.data.defaultCulture;
        // this.linkingByAccounting = resultOne.data.data.linkingByAccounting;
        this.isSalariesEnabled = resultOne.data.data.isSalariesEnabled;
        // this.linkingByWarehouse = resultOne.data.data.linkingByWarehouse;
        this.enableUserDeviceIdVerification =
          resultOne.data.data.enableUserDeviceIdVerification;
        this.isMultiCurrency = resultOne.data.data.isMultiCurrency;
        this.salaryCalculationMethod =
          resultOne.data.data.salaryCalculationMethod;
        this.startingDate = resultOne.data.data.startingDate.split("T")[0];
        // this.CalculateSalriesFromTimeSheet =
        //   resultOne.data.data.calculateSalriesFromTimeSheet;
        this.autoEmployeesBonsesIncrement =
          resultOne.data.data.autoEmployeesBonsesIncrement;
        this.autoVacationBalancesIncrement =
          resultOne.data.data.autoVacationBalancesIncrement;
        this.autoSetMonthlyIncreaseOfVacationMechanism =
          resultOne.data.data.autoSetMonthlyIncreaseOfVacationMechanism;
        this.autoSetMonthlyIncreaseOfVacation =
          resultOne.data.data.autoSetMonthlyIncreaseOfVacation;
        this.autoGetAttendanceLogFromZK =
          resultOne.data.data.autoGetAttendanceLogFromZK;
        this.autoGetAttendanceTimeInMinutes =
          resultOne.data.data.autoGetAttendanceTimeInMinutes;
        this.verifyAttendanceByCoordinates =
          resultOne.data.data.verifyAttendanceByCoordinates;
        this.noTimeInException = resultOne.data.data.noTimeInException;
        this.privateCompanyMode = resultOne.data.data.privateCompanyMode;
        this.isMultiShiftsEnabled = resultOne.data.data.isMultiShiftsEnabled;
        this.enableQrAttendanceVerification =
          resultOne.data.data.enableQrAttendanceVerification;
        this.isTrackingEnabled = resultOne.data.data.isTrackingEnabled;
        this.isAbsenceDeductionEnabled =
          resultOne.data.data.isAbsenceDeductionEnabled;
        this.salaryAbsenceDeductionDays =
          resultOne.data.data.salaryAbsenceDeductionDays;

        this.attendanceDeductionMethod =
          resultOne.data.data.attendanceDeductionMethod;
        this.enableAttendanceService =
          resultOne.data.data.enableAttendanceService;
        this.AbsanceDaysLimit = resultOne.data.data.absenceDaysLimit;
        this.preVacationRequestDaysCount =
          resultOne.data.data.preVacationRequestDaysCount;
        this.isHrVacationApprovalRequired =
          resultOne.data.data.isHrVacationApprovalRequired;
        this.salaryDay = resultOne.data.data.salaryDay;
        this.isNetSalaryRoundingEnabled =
          resultOne.data.data.isNetSalaryRoundingEnabled;

        // this.calculateSalariesByClassification =
        //   resultOne.data.data.calculateSalariesByClassification;
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "الرجاء اعادة تسجيل الدخول"
        );
      }
    },
  },
  watch: {
    globalCompanyInfo(newValue) {
      this.setCompanyInfo();
    },
    // linkingByAccounting() {
    //   if (this.linkingByAccounting == false) {
    //     this.calculateSalariesByClassification = false;
    //   }
    // },

    isSalariesEnabled() {
      if (this.isSalariesEnabled == false) {
        // this.linkingByAccounting = false;
        // this.CalculateSalriesFromTimeSheet = false;
      }
    },
  },
};
</script>
